import { BaseModel } from './BaseInterface';
export const GoalBase: BaseModel[] = [
  {
    key: 'retirement',
    userInput: 'Retirement',
    apiValue: 1,
    dbValue: 1
  },
  {
    key: 'purchase',
    userInput: 'Major Purchase',
    apiValue: 3,
    dbValue: 3
  },
  {
    key: 'income',
    userInput: 'Generate Income',
    apiValue: 6,
    dbValue: 6
  },
  {
    key: 'wealth',
    userInput: 'Building Wealth',
    apiValue: 5,
    dbValue: 5
  }
];
